import { useEffect } from 'react';
import { useAuth } from '@/auth';
import { AppRoutes } from '@/app/AppRoutes';
import { useAppShell } from '@/shell/useAppShell';

export function AppShell() {
  const { user } = useAuth();
  const { setAuthenticatedUser, refreshUserProfile } = useAppShell();

  useEffect(() => {
    setAuthenticatedUser(user);
  }, [setAuthenticatedUser, user]);

  useEffect(() => {
    if (!user) {
      return;
    }

    void refreshUserProfile(user);
  }, [refreshUserProfile, user]);

  return <AppRoutes />;
}
